import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    How does outsourcing to a Python development company work?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>You can collaborate with a well-established third-party firm equipped with a skilled team of Python developers. This choice eliminates the need to hire and maintain an in-house development team.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    How much do you charge for building a Python application?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The typical price range for Python app development by an experienced agency generally falls between $1000 and $5000. Nevertheless, this amount can vary depending on client-requested modifications or specific project requirements.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;